<template>
  <div class="row">
    <div class="records-container">
      <q-table class="records-table" dense :columns="columns" :rows="rows" :pagination="pagination" row-key="id"
        selection="multiple" v-model:selected="selectedDeleteRows" wrap-cells>
        <!-- <template v-slot:body="props">
          <q-tr :props="props">
            <q-td key="organisation" :props="props">{{
              props.row.organisation
            }}</q-td>
            <q-td key="applicationNumber" :props="props">{{
              props.row.applicationNumber
            }}</q-td>
            <q-td key="applicationSubject" :props="props">{{
              props.row.applicationSubject
            }}</q-td>
            <q-td key="customer" :props="props">
              {{ props.row.customer }}
            </q-td>
            <q-td key="importFileName" :props="props">
              {{ props.row.importFileName }}
            </q-td>
            <q-td key="city" :props="props">
              {{ props.row.city }}
            </q-td>
            <q-td key="dateTimeGranted" :props="props">
              {{ props.row.dateTimeGranted }}
            </q-td>
            <q-td key="amount" :props="props">
              {{ props.row.amount }}
            </q-td>
            <q-td key="programTarget" :props="props">
              {{ props.row.programTarget }}
            </q-td>
            <q-td key="schemeName" :props="props">
              {{ props.row.schemeName }}
            </q-td>
            <q-td key="schemeId" :props="props">
              {{ props.row.schemeId }}
            </q-td>
          </q-tr>
        </template> -->
      </q-table>
      <!--    <q-btn
        v-if="anythingSelectedForRemoval"
        class="bg-red-1 q-mr-md"
        icon="las la-2x la-trash la-fw action-icon"
        @click="confirmRemoveRecords = true"
        label="Verwijder geselecteerde"
      /> -->
    </div>

    <q-dialog v-model="confirmRemoveRecords" persistent>
      <q-card>
        <q-card-section class="row items-center">
          <i class="las la-2x la-trash la-fw"></i>
          <span class="q-ml-sm">
            Weet je zeker dat je alle geselecteerde gegevens wilt verwijderen?
          </span>
        </q-card-section>

        <q-card-actions align="right">
          <q-btn style="background: #0a108f; color: white" label="Verwijder geselecteerde data" no-caps v-close-popup
            @click="removeRecords()" />
          <q-btn style="color: #0a108f; border: 1px solid gray; border-radius: 5px" no-caps label="Annuleren" flat
            v-close-popup />
        </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>
<script>
import { ref, computed } from 'vue';
import store from '../../store/index.js';
import RecordsService from '../../services/records.service';
import StatisticsUtils from '../../utils/statistics.js';
import FiltersService from '../../services/filters.service';
import { date } from 'quasar';

export default {
  name: 'StatisticsTableTab',
  setup() {
    const isFomoResearcher = computed({
      get: () => store.state.auth.authUser.isFomoResearcher,
    });
    const formatter = new Intl.NumberFormat('nl-NL', {
      style: 'currency',
      currency: 'EUR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    const columns = [
      {
        name: 'organisation',
        label: 'Verstrekker',
        field: 'organisation',
        sortable: true,
        align: 'left',
      },
      {
        name: 'applicationNumber',
        label: 'Nummer verlening',
        field: 'applicationNumber',
        sortable: true,
        align: 'left',
      },
      {
        name: 'applicationSubject',
        label: 'Aanvraagtitel',
        field: 'applicationSubject',
        sortable: true,
        align: 'left',
      }, // renamed in #4269
      {
        name: 'customer',
        label: 'Ontvanger',
        field: 'customer',
        sortable: true,
        align: 'left',
      },
      {
        name: 'dateTimeGranted',
        label: 'Verl.datum',
        field: 'dateTimeGranted',
        sortable: true,
        align: 'left',
        format: (val) => date.formatDate(val, 'DD-MM-YY'),
      },
      {
        name: 'amount',
        label: 'Verleend bedrag',
        field: 'amount',
        sortable: true,
        align: 'right',
        format: (val) => formatter.format(val)
      }, // renamed in #4269
      {
        name: 'schemeName',
        label: 'Regeling',
        field: (row) =>
          row.schemeId != null && row.schemeIdoxKey != null
            ? row.schemeName
            : 'n.n.b',
        sortable: true,
        align: 'left',
      },
      {
        name: 'importFileName',
        label: 'Bronbestand',
        field: 'importFileName',
        sortable: true,
        align: 'left',
        classes: isFomoResearcher.value ? '' : 'hidden',
        headerClasses: isFomoResearcher.value ? '' : 'hidden',
      },
    ];

    const pagination = ref({
      rowsPerPage: 25,
    });

    const rows = computed({
      get: () => store.state.statistics.statisticsTableRows,
    });

    const selectedDeleteRows = ref([]);
    const anythingSelectedForRemoval = computed({
      get: () => selectedDeleteRows.value.length > 0,
    });
    const confirmRemoveRecords = ref(false);

    return {
      pagination,
      columns,
      rows,
      isFomoResearcher,
      selectedDeleteRows,
      anythingSelectedForRemoval,
      confirmRemoveRecords,
      formatter,
      removeRecords() {
        const fileId = store.state.fileRecords.fileId;
        const removeRecordIds = selectedDeleteRows.value.map((a) => a.id);
        RecordsService.removeRecords(fileId, removeRecordIds);
        // Reset selected rows to be removed
        selectedDeleteRows.value = [];
        // Re-fetch filter data
        FiltersService.getDefaultFilters(); // belive it or not, re-fetching data won't work without this line
        StatisticsUtils.filterRecords();
        StatisticsUtils.customerCounts();
      },
    };
  },
};
</script>
